const FEED_RULE_TYPE_OPTIONS = [
   {
      value: 'all',
      label: 'All',
      name: 'All',
      id: 'all',
   },
   {
      value: 'block',
      label: 'Partial Block',
      name: 'Partial Block',
      id: 'block',
   },
   {
      value: 'full_block',
      label: 'Full Block',
      name: 'Full Block',
      id: 'full_block',
   },
];

export default FEED_RULE_TYPE_OPTIONS;
